export const USE_DUMMY_DATA = true;
export const MAINTENCANCE = false;
export const BOARD_AGRUPATION_WHEN_NULL = true;
export const BOARD_AGGREGATION_WHEN_NULL = false;
export const FILE_MAX_SIZE = 85;

